export type AppEnvironment = 'development' | 'production';

const getHostname = (url?: string): string => {
  if (url) {
    try {
      return new URL(url).hostname.toLowerCase();
    } catch {
      return url.toLowerCase();
    }
  }

  if (typeof window !== 'undefined' && window.location?.hostname) {
    return window.location.hostname.toLowerCase();
  }

  return '';
};

export const getAppEnvironment = (url?: string): AppEnvironment => {
  const hostname = getHostname(url);

  if (!hostname) {
    return 'production';
  }

  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.local');
  const hasDevSegment = /(^|[.-])dev([.-]|$)/.test(hostname);

  return isLocalHost || hasDevSegment ? 'development' : 'production';
};

export const isDevelopmentEnvironment = (url?: string): boolean => {
  return getAppEnvironment(url) === 'development';
};
